export type PersonalizationState = {
  metadata: {
    backgroundStyle: string
    textStyle: string
    textPosition: string
    textColors: { colors: string[]; rotation: number }
    personalizeText: {
      raw: string
    }
  }
}

const initialState = {
  backgroundStyle: '',
  textStyle: 'HouseSlant',
  textPosition: 'center',
  textColors: { colors: ['#211E1C'], rotation: 0 },
  personalizeText: {
    raw: '',
    array: []
  }
}

export const usePersonalizationStore = defineStore('personalizationStore', {
  state: (): PersonalizationState => ({
    metadata: { ...initialState }
  }),
  actions: {
    //   async fetch() {
    //     const infos = await $fetch('https://api.nuxt.com/modules/pinia')
    //     this.name = infos.name
    //     this.description = infos.description
    //   }
    updateMetadata(nextMetadata: Partial<PersonalizationState['metadata']>) {
      this.metadata = { ...this.metadata, ...nextMetadata }
    },
    reset() {
      this.metadata = { ...initialState }
    }
  }
})
